export const clearAll = () => {
    localStorage.clear()
}


export const setNeedResetPwd = () => {
    localStorage.setItem('NeedResetPwd', '1')
}
export const getNeedResetPwd = () => {
    return localStorage.getItem("NeedResetPwd")
}
export const removeNeedResetPwd = () => {
    return localStorage.removeItem("NeedResetPwd")
}

export const setAuthorityToken = (val) => {
    localStorage.setItem('AuthorityToken', val)
}
export const getAuthorityToken = () => {
    return localStorage.getItem("AuthorityToken")
}
export const removeAuthorityToken = () => {
    return localStorage.removeItem("AuthorityToken")
}

export const setUserInfo = (val) => {
    localStorage.setItem('UserInfo', JSON.stringify(val))
}
export const getUserInfo = () => {
    return localStorage.getItem('UserInfo') ? JSON.parse(localStorage.getItem("UserInfo")) : null
}
export const removeUserInfo = () => {
    return localStorage.removeItem("UserInfo")
}

export const setPermissions = (val) => {
    localStorage.setItem('Permissions', JSON.stringify(val))
}
export const getPermissions = () => {
    return localStorage.getItem('Permissions') ? JSON.parse(localStorage.getItem("Permissions")) : null
}
export const removePermissions = () => {
    return localStorage.removeItem("Permissions")
}

export const setPersonalConfigList = (val) => {
    localStorage.setItem('PersonalConfigList', JSON.stringify(val))
}
export const getPersonalConfigList = () => {
    return localStorage.getItem('PersonalConfigList') ? JSON.parse(localStorage.getItem("PersonalConfigList")) : null
}
export const removePersonalConfigList = () => {
    return localStorage.removeItem("PersonalConfigList")
}

export const setRoles = (val) => {
    localStorage.setItem('Roles', JSON.stringify(val))
}
export const getRoles = () => {
    return localStorage.getItem('Roles') ? JSON.parse(localStorage.getItem("Roles")) : null
}
export const removeRoles = () => {
    return localStorage.removeItem("Roles")
}




export const setOriginRouters = (val) => {
    localStorage.setItem('OriginRouters', JSON.stringify(val))
}
export const getOriginRouters = () => {
    return localStorage.getItem('OriginRouters') ? JSON.parse(localStorage.getItem("OriginRouters")) : null
}
export const removeOriginRouters = () => {
    return localStorage.removeItem("OriginRouters")
}





export const setTenantSimplifiedPojo = (val) => {
    localStorage.setItem('TenantSimplifiedPojo', JSON.stringify(val))
}
export const getTenantSimplifiedPojo = () => {
    return localStorage.getItem('TenantSimplifiedPojo') ? JSON.parse(localStorage.getItem("TenantSimplifiedPojo")) : null
}
export const removeTenantSimplifiedPojo = () => {
    return localStorage.removeItem("TenantSimplifiedPojo")
}


export const setCommoditySelectType = (val) => {
    localStorage.setItem('CommoditySelectType', val)
}
export const getCommoditySelectType = () => {
    return localStorage.getItem("CommoditySelectType")
}
export const removeCommoditySelectType = () => {
    return localStorage.removeItem("CommoditySelectType")
}


// WEBPACK FOOTER //
// ./src/utils/storageUtil.js